import classNames from "classnames";
import styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import Modal from "../../../../../../components/common/Modal";
import PrimaryButton from "../../../../../../components/common/PrimaryButton";
import OutlinedButton from "../../../../../../components/common/OutlinedButton";

interface ISuccessModalProps {
  handleClose: () => void;
  modalOpen: boolean;
  email: string;
  /** The invitation email went out (false: the user was added but it must be sent again). */
  inviteSent: boolean;
  /** The person already had an account, so no invitation was needed. */
  existingAccount: boolean;
  resending: boolean;
  onResend: () => void;
}

/** Shown after adding a user: the user is told by email to choose a password; none is shown here. */
const SuccessModal = ({
  handleClose,
  modalOpen,
  email,
  inviteSent,
  existingAccount,
  resending,
  onResend,
}: ISuccessModalProps) => {
  const { t } = useTranslation();

  let description = t("lbl_invite_not_sent");
  if (existingAccount) {
    description = t("lbl_invite_existing_account");
  } else if (inviteSent) {
    description = t("lbl_invite_sent", { email });
  }

  return (
    <Modal
      visible={modalOpen}
      onCancel={handleClose}
      customModalClassName={styles.modalContainer}>
      <div className={classNames(styles.container)}>
        <img src="/assets/images/svg/Success_tick.svg" alt="success" />

        <div className={styles.headerContainer}>
          <h1 className={styles.title}>{t("lbl_success_add_user")} </h1>
          <p className={styles.description}>{description}</p>
        </div>

        <div className={styles.dataContainer}>
          <div className={styles.dataContentContainer}>
            <img src="/assets/images/svg/email.svg" alt="email" />
            <div className={styles.dataContent}>
              <p className={styles.dataTitle}>{t("email")}</p>
              <p className={styles.dataDescription}>{email}</p>
            </div>
          </div>
        </div>

        {!existingAccount && (
          <PrimaryButton
            onClick={onResend}
            disabled={resending}
            style={{
              width: "100%",
              height: "48px",
              borderRadius: "8px",
              fontSize: "1rem",
              fontWeight: 600,
              marginTop: "40px",
              background: "#0D44AD",
            }}>
            {inviteSent ? t("lbl_resend_invite") : t("lbl_send_invite")}
          </PrimaryButton>
        )}
        <OutlinedButton
          onClick={handleClose}
          style={{
            width: "100%",
            color: "#0C4BC4",
            background: "#0C4BC41A",
            border: "none",
            fontSize: "1rem",
            fontWeight: 400,
            height: "48px",
            marginTop: "15px",
          }}>
          {t("close")}
        </OutlinedButton>
      </div>
    </Modal>
  );
};

export default SuccessModal;
